import { RealEstateObject } from '@immosky/types';

export type LocalStorageKey = string;

export class LocalStorage {
  static updateForDetailPage(objects: RealEstateObject[]) {
    const data = {
      objectIDs: objects.map((object: RealEstateObject) => {
        return object.id;
      }),
      filterUrl: window.location.href,
    };

    this.set('detailPageData', JSON.stringify(data));
  }

  private static set(key: LocalStorageKey, value: string) {
    localStorage.setItem(key, value);
  }

  private static get(key: LocalStorageKey): string | null {
    return localStorage.getItem(key);
  }
}
